<template>
  <div class="list-page font-sc-re" v-if="search_type">
    <industry-detail
      v-if="search_type < 3"
      :keywords="keywords"
      :search_type="search_type"
      :from="from"
    ></industry-detail>
    <competitor-detail
      v-if="search_type == 3"
      :keywords="keywords"
      :oils_type="oils_type"
    ></competitor-detail>
  </div>
</template>

<script>
import { onMounted, reactive, toRefs } from "vue";
import { useRoute } from "vue-router";
import IndustryDetail from "./components/IndustryDetail";
import CompetitorDetail from "./components/CompetitorDetail";
export default {
  name: "List",
  components: {
    IndustryDetail,
    CompetitorDetail
  },
  props: {},
  setup() {
    const route = useRoute();
    let data = reactive({
      search_type: 0,
      keywords: "",
      oils_type: "",
      from: "" // 是否从首页搜索进入
    });
    onMounted(() => {
      data.search_type = route.query.search_type;
      data.keywords = route.query.keywords;
      data.oils_type =
        route.query.search_type == 3 ? route.query.oils_type : "";
      data.from = route.query.from || "";
    });
    return {
      ...toRefs(data)
    };
  }
};
</script>

<style lang="sass" scoped>
@import "~@/styles/mixins/vw"
.list-page
  min-height: 100vh
.list-page::-webkit-scrollbar
  display: none
</style>
